import { Channel } from '../../../../types/working-model';
import { resizedImage } from 'utils/utils';
import './channel-avatar.scss';

interface ChannelAvatarProps {
	channel: Channel;
}

const ChannelAvatar = ({ channel }: ChannelAvatarProps): JSX.Element => {
	const avatarSrc = channel.logos.color || channel.logos.white || channel.logos.gray;

	return (
		<div className="channel-avatar" style={{ backgroundColor: channel.colors.primary || '#333333' }}>
			{avatarSrc
				? <img src={resizedImage(avatarSrc, { height: 64, width: 64, fit: 'contain' })} alt={channel.name} />
				: <h5>{channel.name[0]}</h5>}
		</div>
	);
};

export default ChannelAvatar;
